class WindowHelper {
  private isAddRemovePrint = false;

  addRemovePrintListener() {
    if (this.isAddRemovePrint) {
      return;
    }

    window.onbeforeprint = () => {
      document.querySelectorAll('.noPrint').forEach(el => {
        el.style.opacity = '0';
      });
    };

    window.onafterprint = () => {
      document.querySelectorAll('.noPrint').forEach(el => {
        el.style.opacity = '1';
      });

      // 隱藏列印內容
      document.body.classList.remove('is-printing');
    };

    this.isAddRemovePrint = true;
  }
}

export const windowHelper = new WindowHelper();
